import React from 'react';
import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  Tooltip,
} from '@mui/material';
import { Palette } from 'Palette';
import { determineNextTone } from './styles';

export interface ToneIconButtonProps extends MuiIconButtonProps {
  tooltip?: string;
  children: React.ReactNode;
}

const ToneIconButton: React.FC<ToneIconButtonProps> = ({ tooltip, children, ...props }) => {
  const standardPalette = Palette.default;
  const hoverPalette = Palette[determineNextTone('default')];
  const backgroundColor = standardPalette.buttonBg;
  const color = standardPalette.buttonText;
  const hoverColor = hoverPalette.buttonText;
  const hoverBackgroundColor = hoverPalette.buttonBg;

  const button = (
    <MuiIconButton
      sx={{
        color,
        backgroundColor,
        '&:hover': {
          color: hoverColor,
          backgroundColor: hoverBackgroundColor,
        },
      }}
      {...props}
      className={`react-ToneIconButton ${props.className || ''}`.trim()}
    >
      {children}
    </MuiIconButton>
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};

export default ToneIconButton;
